var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSitin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26838 12.6625H17.7316C18.9098 12.6625 20 13.381 20 14.4691C20 15.5567 18.9098 16.2753 17.7316 16.2753H3.26838C2.09018 16.2753 1 15.5567 1 14.4691C1 13.381 2.09018 12.6625 3.26838 12.6625V12.6625Z",
    fill: "none",
    strokeWidth: 1.82406
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12143 12.5312H14.8786L15.9858 3.31136C16.0364 2.89042 15.905 2.47969 15.6168 2.15484C15.3038 1.80109 14.8442 1.59912 14.3556 1.59912H6.64441C6.15587 1.59912 5.69624 1.80151 5.38288 2.15442C5.09418 2.47969 4.96322 2.89085 5.01381 3.31136L6.12143 12.5312Z",
    fill: "none",
    strokeWidth: 2.10469
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0533 15.9901H16.158V23.3561C16.158 23.9373 15.6868 24.4084 15.1056 24.4084C14.5244 24.4084 14.0533 23.9373 14.0533 23.3561V15.9901ZM5.63452 15.9901H7.73921V23.3561C7.73921 23.9373 7.2681 24.4084 6.68686 24.4084C6.10563 24.4084 5.63452 23.9373 5.63452 23.3561V15.9901Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitin);
export default __webpack_public_path__ + "static/media/SITIN.d12cc65a.svg";
export { ForwardRef as ReactComponent };